import $ from 'jquery';
import BasePropertyView from 'BasePropertyView.js';
import util from 'util/Util.js';
import valueTemplate from 'properties/main/timer.ejs';

class MainTimerView extends BasePropertyView {

    initialize( opts ) {
        this.options = opts || {};
        this.template = valueTemplate;
        this.tagName = 'div';
        this.id = opts.el;
        this.config = opts.config || {};
        this.measure = 'Seconds';

        this.events = {
            'change input[type=checkbox]': 'updateCheckboxAttributes',
            'change input[type=text]': 'updateAttributes',
            'blur input[type=text]'   : 'lostFocus',
            'focus input[type=text]'   : 'getFocus',
            'change #measure': 'updateAttributes',
            'change #direction': 'updateAttributes',
            'keydown input[type=text]' : 'validateInputKeyPressed'
        }

        if (!this.model.get('startTime')) {
            this.model.set('startTime', '0', {silent: true});
        }

        if (!this.model.get('endTime')) {
            this.model.set('endTime', '60', {silent: true});
        }

        if (!this.model.get('interval')) {
            this.model.set('interval', '1', {silent: true});
        }

        if (!this.model.get('measure')) {
            this.model.set('measure', 'Seconds', {silent: true});
        }

        if (!this.model.get('direction')) {
            this.model.set('direction', 'up', {silent: true});
        }

        if (!this.model.get('loop')) {
            this.model.set('loop', 'false', {silent: true});
        }

        let displayInterval = this.minutesOrSeconds(this.model.get('interval'));
        this.model.set('displayInterval', displayInterval, {silent:true});

        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.value;

        if (propName === 'measure') {
            let int = this.model.get('displayInterval');
            if (propVal === 'Minutes') {
                int = this.model.get('displayInterval') * 60;
            }
            this.model.set('interval', int, {silent:true});
            this.model.set(propName, propVal);
        } else if (propName === 'interval') {
            if (this.model.get('measure') === 'Minutes') {
                let int = propVal * 60;
                this.model.set('displayInterval', propVal, {silent: true});
                this.model.set('interval', int);
            } else {
                this.model.set('displayInterval', propVal, {silent: true});
                this.model.set('interval', propVal);
            }
        } else {
            this.model.set(propName, propVal);
        }


    }

    updateCheckboxAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.checked;

        this.model.set( propName, propVal );
    }

    minutesOrSeconds(val) {
        // determine if value is divisble by 60, then set to Minutes else Seconds.
        let interval = val;

        if (val) {
            if ((val % 60 === 0) ) {
                this.model.set('measure', 'Minutes', {silent:true});
                interval = val / 60;
            }
            else {
                //this.model.set('measure', 'Seconds', {silent:true});
            }
        }

        return interval;
    }

    validateInputKeyPressed(ev) {
        const propName = ev.currentTarget.name;

        if ($.inArray(propName, ['startTime','endTime','interval']) !== -1) { //Apply all validation rules to the input text for numeric value
            let allowNegative = util.isTrue(this.model.get('allowNegative'));

            if ($.inArray(ev.keyCode, [8, 9, 13, 27, 46]) !== -1 ||
                // Allow: Ctrl+C, Command+C, Ctrl+V, Command+V, Ctrl+X, Command+X
                ((ev.keyCode === 67 || ev.keyCode === 86 || ev.keyCode === 88) && (ev.ctrlKey === true || ev.metaKey === true)) ||
                // Allow: home, end, left, right, down, up
                (ev.keyCode >= 35 && ev.keyCode <= 40)) {
                return;
            }

            if ($.inArray(ev.keyCode, [109, 189]) !== -1) {
                //If negative is allowed then avoid introducing more than one sign
                if (!allowNegative || ev.currentTarget.value.indexOf('-') !== -1) {
                    ev.preventDefault();
                }
            } else if ($.inArray(ev.keyCode, [110, 190]) !== -1) {
                //If decimal point is allowed then avoid introducing more than one point
                if (ev.currentTarget.value.indexOf('.') !== -1) {
                    ev.preventDefault();
                }
            } else if ((ev.shiftKey || (ev.keyCode < 48 || ev.keyCode > 57)) && (ev.keyCode < 96 || ev.keyCode > 105)) {
                // Ensure that it is a number and stop the keypress
                ev.preventDefault();
            }
        }
    }

    render() {
        this.$el.empty();

        let props = this.model.toJSON();



        if(this.template) {
            this.$el.html(this.template(props));
        }

        //set selected index to model value
        $('#measure').find('option[value='+props.measure+']').attr('selected', true);

        if(this.model.get('direction')) {
            $('#direction').find('option[value='+this.model.get('direction')+']').attr('selected', true);
        }

        let bLoop = util.isTrue(this.model.get('loop'));
        $(`input[name='loop']`).prop('checked', bLoop );

        if (this.config.showTitle) {
            this.$el.find('#timerTitle').removeClass('hide');
        }

        this.delegateEvents();
        return this;
    }

}

export default MainTimerView;
